// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"e8f30867","69":"7d9b75a9","128":"c7f30c68","279":"9a95f64a","288":"baf1aef3","295":"99daac27","490":"57f9f42a","509":"3c2611c2","578":"d7c5bc29","584":"e64306cb","590":"ea05fbb0","606":"35e3e296","773":"10e9d33d","823":"5f061e51"}[chunkId] + ".chunk.js";
};